import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Container } from '../../base/Grid';
import { GeneralSection } from './styles';

export const SectionContainerComponent = React.forwardRef(
  ({
    children, className, id, variant, moduleName, moduleVariation,
  }, ref) => {
    const classNames = {};
    classNames[className] = className;
    const compiledId = `${id}-section-container`;

    return (
      <GeneralSection
        id={compiledId}
        variant={variant}
        className={classnames(classNames, className)}
        data-module={`${compiledId}:${moduleName}:${moduleVariation}`}
        ref={ref}>
        <Container>{children}</Container>
      </GeneralSection>
    );
  },
);

SectionContainerComponent.propTypes = {
  /** Children components placed inside the section */
  children: PropTypes.any.isRequired,
  /** Custom class name to add to Type. */
  className: PropTypes.string,
  /** Id for the section */
  id: PropTypes.string.isRequired,
  /**  Variant determines the look and feel of the Section */
  variant: PropTypes.string.isRequired,
  // variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,
  /**  Used to populate and define a module on the section for a given page, used in adobe. (Ex: hero, intro-callout, content-hub) */
  moduleName: PropTypes.string,
  moduleVarition: PropTypes.string,
};

SectionContainerComponent.defaultProps = {
  className: null,
  variant: 'primary',
  moduleName: 'unknown',
  moduleVariation: 'A',
};

export default SectionContainerComponent;
